import { ChangeEvent, FC, useEffect, useState } from "react";
import styles from "@/styles/common/InputFile.module.scss";
import { checkFile } from "@/utils/common/files";
import { useStore } from "@/store/index";

const InputFile: FC<{
    initialData?: File | null;
    onChageFile: (f: File) => void;
    label?: string;
    id?: string;
}> = ({
    onChageFile,
    label = "Choose file...",
    initialData = null,
    id = "file",
}) => {
    const [file, setFile] = useState<File | null>(initialData);
    const setMessageError = useStore(state => state.setErrorMsg);
    const dispatchCommon = useStore(state => state.dispatchCommon);

    const handleFileChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const fileData = evt.target.files && evt.target.files[0];

        if (!fileData) return;

        if (
            checkFile(fileData, 2000, ["image/jpeg", "image/png"], m =>
                setMessageError({ message: m })
            )
        ) {
            const reader = new FileReader();

            const onStart = () => {
                setFile(null);
                dispatchCommon({ type: "RESET_COMMON" });
            };

            const onEnd = () => {
                setFile(fileData);
                if (fileData) onChageFile(fileData);
            };

            reader.addEventListener("load", () => {
                setFile(fileData);
            });
            reader.addEventListener("loadstart", onStart);
            reader.addEventListener("abort", onEnd);
            reader.addEventListener("error", onEnd);
            reader.addEventListener("loadend", onEnd);
            reader.readAsDataURL(fileData);
        } else {
            evt.preventDefault();
        }
    };

    useEffect(() => {
        if (file) onChageFile(file);
    }, [file]);

    return (
        <label className={styles.file} htmlFor={id}>
            <input type="file" id={id} onChange={handleFileChange} />
            <span className={styles.fileCustom}>
                {(file && file?.name) || label}
            </span>
        </label>
    );
};

export default InputFile;
